import Lookup from 'src/componentes/select2';

const FormularioComplementarOpcoesRespostaLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/FormularioComplementarOpcoesRespostaLookup"
    clearable={true}
    {...rest}
  />
);

export default FormularioComplementarOpcoesRespostaLookup;
